import { get } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';

// workaroud for class component to init share hook
function InitShare({ config }) {

  const pageKey = get(config, ['page', 'key'], null);
  useQuery(['share-service', pageKey], () => { return {}; }, {
    staleTime: Infinity,
  });

  return <></>;
}

export default InitShare;
